declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const f = window as Window
  const n: ((...args: unknown[]) => void) & {
    callMethod?: (...args: unknown[]) => void
    queue: unknown[][]
    push: (...args: unknown[]) => void
    loaded: boolean
    version: string
  } = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod(...args)
    } else {
      n.queue.push(args)
    }
  } as typeof n

  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  f.fbq = n
  if (!f._fbq) f._fbq = n

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = document.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', '776524068662312')
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Más Que Padres',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
